import { combineReducers } from 'redux';

import * as types from 'modules/chat/actionTypes';
import { CONVERSATION_HISTORY } from 'modules/chat/constant';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  selected: string | null,
 *  list: import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer,
 * }} ChatUIDetailsHistoryReducer
 */

const matcher = ({ meta }) => meta?.source === CONVERSATION_HISTORY;

const listReducer = createSearchReducers(types.FETCH_CONVERSATION_HISTORY, {
  global: {
    matcher,
  },
});

export default combineReducers({
  selected: createReducer(null, {
    [types.SET_HISTORY_ID]: (_, { payload: { historyId } }) => historyId,
    [LOCATION_CHANGE]: () => null,
  }),
  list: (state, action) => (action.type === LOCATION_CHANGE ? listReducer(undefined, action) : listReducer(state, action)),
});
